import {auth} from '@/agiles/common/auth';
import Vue from 'vue';
import SignUp from './SignUp.vue';

new Vue({render: h => h(SignUp),}).$mount('#app');

